import React from "react";

const GroupAvatar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="412"
    height="412"
    x="0"
    y="0"
    version="1.1"
    viewBox="-100 -100 700 700"
    xmlSpace="preserve"
  >
    <g fill="white" width="50" height="50">
      <path
        width="50"
        height="50"
        d="M112.066 319.819c21.252-14.114 44.849-21.851 67.67-29.382 3.279-1.078 6.554-2.137 9.813-3.239l.668-.221c4.822-1.689 9.393-3.284 13.134-5.345.169-.394.411-1.049.7-2.135-18.788-27.428-31.554-69.82-31.554-106.136 0-30.807 9.682-53.629 27.941-67.526-7.894-3.991-17.416-5.527-27.663-5.527-27.307 0-49.442 10.91-49.442 50.082 0 26.007 9.755 57.906 24.296 76.43a51.082 51.082 0 01-.571 4.388c-.867 3.979-2.261 8.437-5.981 10.646-4.174 2.478-8.81 4.051-13.372 5.649-18.912 6.365-38.472 11.975-55.258 23.121-8.727 5.745-14.639 15.713-17.9 25.506-3.359 10.163-4.733 24.371-4.526 32.371h51.575c3.272-4.001 6.758-6.243 10.47-8.682zM457.457 296.129c-3.263-9.793-9.178-19.379-17.9-25.125-16.79-11.145-36.352-16.946-55.262-23.307-4.563-1.598-9.197-3.267-13.366-5.746-3.726-2.213-5.121-6.715-5.982-10.698a51.793 51.793 0 01-.736-6.378c13.712-18.761 22.809-49.369 22.809-74.471 0-39.18-22.137-50.097-49.443-50.097-10.385 0-20.009 1.594-27.967 5.706 18.105 13.913 27.697 36.684 27.697 67.366 0 35.358-11.861 76.072-29.895 103.673.049.313.097.619.153.925.475 2.141.864 3.259 1.106 3.814 3.955 2.205 8.687 3.935 13.973 5.794l7.919 2.639c23.412 7.773 47.621 15.722 69.428 30.19 3.524 2.325 6.852 4.085 9.971 8.085h52.019c.208-7.999-1.168-22.207-4.524-32.37z"
      />
    </g>
    <path
      fill="white"
      width="50"
      height="50"
      d="M414.744 368.006c-4.354-13.059-12.239-25.999-23.867-33.668-22.386-14.854-48.47-22.674-73.685-31.155-6.084-2.133-12.264-4.395-17.82-7.701-4.969-2.953-6.827-8.97-7.979-14.28a69.987 69.987 0 01-.981-8.519c18.282-25.013 30.413-65.829 30.413-99.3 0-52.24-29.516-66.796-65.926-66.796-36.408 0-65.922 14.541-65.922 66.776 0 34.67 13.006 77.204 32.395 101.912-.181 1.947-.41 3.902-.76 5.842-1.159 5.303-3.018 11.249-7.975 14.194-5.568 3.308-11.749 5.399-17.832 7.532-25.215 8.489-51.297 15.965-73.677 30.827-11.636 7.661-19.52 21.277-23.867 34.336-4.48 13.551-6.311 30.494-6.035 43.494H420.771c.282-13-1.552-29.944-6.027-43.494z"
    />
  </svg>
);

export default GroupAvatar;
